import type { Core } from 'chessboard/core/config/types';

/**
 * Create a core event to be passed to the plugins.
 */
export function createCoreEvent<T>(type: T, data?: any): Core.Event<T> {
  return {
    data: data || {},
    type,
  };
}
